import React from 'react';
import { makeStyles, TextField, TextFieldProps, Typography } from '@smile-next/uikit';

type Props = TextFieldProps & {
    /** テキストフィールド横のラベル */
    label: string;
};

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    label: {
        height: 40,
        display: 'flex',
        flex: '0 0 120px',
        justifyContent: 'flex-end',
        alignItems: 'center',
        paddingRight: theme.spacing(2),
    },
    textField: {
        flex: '1 0 0',
    },
}));

export const LoginFormTextField = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
    const { label, ...other } = props;
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Typography className={classes.label} variant="body1">
                {label}
            </Typography>
            <TextField classes={{ root: classes.textField }} dense ref={ref} {...other} />
        </div>
    );
});
